import { FIELD_DEFINITIONS, FIELD_TYPE_REGISTRY } from "./registryMetadata";

const SIMPLE_TYPE_TO_KEY = Object.fromEntries(
  Object.values(FIELD_DEFINITIONS).map((def) => [def.simpleType, def.key])
);

const CUSTOMCLASS_TO_KEY = Object.fromEntries(
  Object.values(FIELD_DEFINITIONS).map((def) => [def.javaClass, def.key])
);

const warnedUnknownTypes = new Set();

const warnUnknownType = (typeKey) => {
  if (warnedUnknownTypes.has(typeKey)) return;
  warnedUnknownTypes.add(typeKey);
  if (process.env.NODE_ENV !== "production") {
    console.warn(
      `[field-types] Unknown field type "${typeKey}". Register it in field-types/registryMetadata.js.`
    );
  }
};

export const resolveTypeKey = (typeOrClass = "STRING") => {
  if (!typeOrClass) return "STRING";
  if (typeof typeOrClass !== "string") return "STRING";

  const upper = typeOrClass.toUpperCase();
  if (FIELD_TYPE_REGISTRY[upper]) return upper;

  if (SIMPLE_TYPE_TO_KEY[typeOrClass]) return SIMPLE_TYPE_TO_KEY[typeOrClass];
  if (CUSTOMCLASS_TO_KEY[typeOrClass]) return CUSTOMCLASS_TO_KEY[typeOrClass];

  if (/^[A-Z][A-Z0-9_]*$/.test(upper)) {
    warnUnknownType(upper);
    return upper;
  }

  return "STRING";
};

export const isKnownFieldType = (typeOrClass) => {
  const key = resolveTypeKey(typeOrClass);
  return Boolean(FIELD_TYPE_REGISTRY[key]);
};

export const getDefinitionForType = (typeOrClass) => {
  const key = resolveTypeKey(typeOrClass);
  return FIELD_DEFINITIONS[key] || FIELD_DEFINITIONS.STRING;
};

export const getRegistryEntry = (typeOrClass) => {
  const key = resolveTypeKey(typeOrClass);
  return FIELD_TYPE_REGISTRY[key] || null;
};

export const semanticToVisibleType = (typeOrClass) =>
  getDefinitionForType(typeOrClass).simpleType;

export const getIconForType = (typeOrClass) =>
  getDefinitionForType(typeOrClass).icon;

export const getIconClassForType = (typeOrClass) =>
  getDefinitionForType(typeOrClass).iconClass || "fi fi-rr-text";
